// @ts-nocheck
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { FALLBACK_SERVICES, hasCategories } from "../../data/fallback";
import { API_URL } from "../../config/api";

const PUBLIC_TOKEN = "eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJkZW5pcy5taW1pbmlAY2xpY2thbGJhbmlhLmNvbSIsImlhdCI6MTc1MDk4MjU3NywiZXhwIjoxNzUxMjQxNzc3fQ.yQ3xGQEfpj62ruJoLJYOl3966g55OlyofRqjoAHzu";
// const PUBLIC_TOKEN = process.env.REACT_APP_STATIC_TOKEN;


//     const API_URL =
// process.env.NODE_ENV === "development"
//     ? process.env.REACT_APP_API_URL_LOCAL
//     : process.env.REACT_APP_API_URL_PROD;

// Async thunk to fetch services from API
export const fetchServicesFromApi = createAsyncThunk(
    "services/fetchFromApi",
    async ({ businessid }, { rejectWithValue }) => {
        try {
            const response = await fetch(
                `${API_URL}/api/menu-item/room-service/business/${businessid}`,
                {
                    headers: {
                        Authorization: `Bearer ${PUBLIC_TOKEN}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                const errorMessage = errorData?.message || "Failed to fetch services";
                throw new Error(errorMessage);
            }

            const text = await response.text();
            try {
                const data = JSON.parse(text);
                return data;
            } catch (parseError) {
                throw new Error("Invalid JSON received from server");
            }
        } catch (err) {
            return rejectWithValue(err.message);
        }
    }
);

const initialState = {
    services: [],
    status: "idle",
    error: null,
    // True while the list on screen is the bundled copy rather than the API's answer.
    usedFallback: false,
};

const servicesSlice = createSlice({
    name: "services",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchServicesFromApi.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(fetchServicesFromApi.fulfilled, (state, action) => {
                const live = hasCategories(action.payload);
                state.status = "succeeded";
                state.services = live ? action.payload : FALLBACK_SERVICES;
                state.usedFallback = !live;
                state.error = null;
            })
            .addCase(fetchServicesFromApi.rejected, (state, action) => {
                // Same reasoning as the menu: show the bundled list rather than nothing.
                state.status = "failed";
                state.services = FALLBACK_SERVICES;
                state.usedFallback = true;
                state.error = action.payload;
            });
    },
});

export default servicesSlice.reducer;

export const selectAllServices = (state) => state.services.services;
export const selectServicesStatus = (state) => state.services.status;
export const selectServicesError = (state) => state.services.error;
export const selectServicesUsedFallback = (state) => state.services.usedFallback;
